import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAINTENANCE_CONFIG } from '../maintenance.token';

/**
 * Componente que representa la pantalla de mantenimiento de la aplicación.
 * @description
 * Muestra un mensaje informativo al usuario cuando la aplicación o sus servicios
 * no se encuentran disponibles debido a tareas de mantenimiento.
 *
 * @example
 * Uso en una plantilla HTML
 * <app-maintenance></app-maintenance>
 *
 * @usageNotes
 * Utilice este componente para informar al usuario que el sistema se encuentra
 * temporalmente fuera de servicio o con acceso restringido por mantenimiento.
 *
 * @since 2.1.1
 */
@Component({
  selector: 'app-maintenance',
  imports: [],
  templateUrl: './maintenance.component.html',
  styleUrl: './maintenance.component.scss',
  host: {
    class: 'ft-page'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaintenanceComponent {

  readonly config = inject(MAINTENANCE_CONFIG);
}
